const validateDateTimes = (dateTime, holiday = null) => {
    const errors = {};

    errors.startDate = dateTime?.dates?.start?.plain === null
        ? "Choose a first date"
        : "";

    errors.endDate = dateTime?.repeatType !== "no-repeat"
    && dateTime?.repeatType !== undefined
    && dateTime?.dates?.end?.plain === null
        ? "Choose a last date"
        : "";

    errors.startTime = dateTime.times.start === null
        ? "Choose a start time"
        : "";

    errors.endTime = dateTime.times.end === null
        ? "Choose an end time"
        : "";

    if (holiday !== null && dateTime.repeatType !== "no-repeat") {
        errors.addHoliday = holiday === "" || holiday === undefined
            ? "Chose one option"
            : "";
    } else {
        errors.addHoliday = "";
    }

    return errors;
};

export default validateDateTimes;
